import $ from "jquery";
import "slick-carousel";
import imagesLoaded from "imagesloaded";

export function initSplitBanner() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=split-banner",
			splitBanner
		);
	}
}

export function splitBanner() {
	if (!document.querySelectorAll(".split-slideshow").length) return false;

	loadJS(
		"//api.addressnow.co.uk/js/addressnow-2.20.min.js?key=kx88-my93-ct69-wt77",
		false,
		() => {
			if (typeof addressNow !== "undefined") {
				addressNow.listen("options", function (options) {
					options.bar = options.bar || {};
					options.bar.visible = false;
				});
			}
		}
	);
	loadCSS(
		"//api.addressnow.co.uk/css/addressnow-2.20.min.css?key=kx88-my93-ct69-wt77"
	);

	var $slider = $(".slideshow--left");
	var maxItems = $(".item", $slider).length;
	var dragging = false;
	var tracking;
	var rightTracking;
	var newTracking;

	var getRandomNumber = function (min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	var randomStartIndex = getRandomNumber(1, maxItems);

	var $sliderRight = $(".slideshow--right .slider");
	var $sliderHeading = $(".slideshow__text--heading");
	var $sliderSubheading = $(".slideshow__text--subheading");

	imagesLoaded(
		document.querySelector(".slideshow--left .slider"),
		function (instance) {
			$(".slideshow--left .slider")
				.slick({
					vertical: true,
					verticalSwiping: true,
					arrows: false,
					infinite: true,
					dots: false,
					speed: 1000,
					cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
					autoplay: true,
					autoplaySpeed: 7000,
					lazyLoad: "progressive",
				})
				.on(
					"beforeChange",
					function (event, slick, currentSlide, nextSlide) {
						if (
							currentSlide > nextSlide &&
							nextSlide == 0 &&
							currentSlide == maxItems - 1
						) {
							var sliderRightGoTo = -1;
							var sliderHeadingsGoTo = maxItems;
						} else if (
							currentSlide < nextSlide &&
							currentSlide == 0 &&
							nextSlide == maxItems - 1
						) {
							var sliderRightGoTo = maxItems;
							var sliderHeadingsGoTo = -1;
						} else {
							var sliderRightGoTo = maxItems - 1 - nextSlide;
							var sliderHeadingsGoTo = nextSlide;
						}

						$sliderRight.slick("slickGoTo", sliderRightGoTo);
						$sliderHeading.slick("slickGoTo", sliderHeadingsGoTo);
						$sliderSubheading.slick(
							"slickGoTo",
							sliderHeadingsGoTo
						);
					}
				)
				.on("mousewheel", function (event) {
					if (event.deltaX > 0 || event.deltaY < 0) {
						$(this).slick("slickNext");
					} else if (event.deltaX < 0 || event.deltaY > 0) {
						$(this).slick("slickPrev");
					}
				})
				.on("mousedown touchstart", function () {
					dragging = true;
					tracking = $(".slick-track", $slider).css("transform");
					tracking = parseInt(tracking.split(",")[5]);
					rightTracking = $(".slideshow--right .slick-track").css(
						"transform"
					);
					rightTracking = parseInt(rightTracking.split(",")[5]);
				})
				.on("mousemove touchmove", () => {
					if (dragging) {
						newTracking = $(".slideshow--left .slick-track").css(
							"transform"
						);
						newTracking = parseInt(newTracking.split(",")[5]);
						var diffTracking = newTracking - tracking;
						$(".slideshow--right .slick-track").css({
							transform:
								"matrix(1, 0, 0, 1, 0, " +
								(rightTracking - diffTracking) +
								")",
						});
					}
				})
				.on("mouseleave touchend mouseup", () => {
					dragging = false;
				});
		}
	);

	imagesLoaded(
		document.querySelector(".slideshow--right .slider"),
		function (instance) {
			$sliderRight.slick({
				swipe: false,
				dots: false,
				vertical: true,
				arrows: false,
				infinite: true,
				speed: 950,
				cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
				initialSlide: maxItems - 1,
				lazyLoad: "progressive",
			});
		}
	);

	$(".slideshow__text--heading").slick({
		swipe: false,
		vertical: true,
		arrows: false,
		infinite: true,
		speed: 900,
		cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
	});

	$(".slideshow__text--subheading").slick({
		swipe: false,
		vertical: false,
		fade: true,
		arrows: false,
		infinite: true,
		speed: 1200,
		cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
	});
}

function loadJS(FILE_URL, async = true, callback) {
	let scriptEle = document.createElement("script");
	scriptEle.setAttribute("src", FILE_URL);
	scriptEle.setAttribute("type", "text/javascript");
	scriptEle.setAttribute("async", async);
	document.body.appendChild(scriptEle);
	scriptEle.addEventListener("load", () => {
		callback();
	});
}

function loadCSS(FILE_URL) {
	let linkEle = document.createElement("link");
	linkEle.setAttribute("href", FILE_URL);
	linkEle.setAttribute("type", "text/css");
	linkEle.setAttribute("media", "all");
	linkEle.setAttribute("rel", "stylesheet");
	document.head.appendChild(linkEle);
}
